export default "__VITE_ASSET__DRfJVsHR__"